import { jsx, jsxs } from 'react/jsx-runtime';
import { findDOMNode } from 'react-dom';
import React__default from 'react';
import cns from '../../node_modules/classnames/index.js';
import { getProp, setProp } from '../Utils/formHelpers.js';
import Validation, { getValidation } from '../Validation/index.js';
import nodeHelpers from '../Utils/nodeHelpers.js';
import Option from './Option.js';
import Divider from './Divider.js';
import doesNodeContainClick from '../Utils/doesNodeContainClick.js';
import { getTitle, getRandomId, Presentation } from '../Utils/baseComponentHelper.js';
import EllipsisText from '../EllipsisText/EllipsisText.js';
import useValidations from '../Hooks/useValidations.js';
import ValidationViewer from '../Validation/ValidationViewer.js';
import useActivation from '../Hooks/useActivation.js';
import { isTabEvent, KeyboardEventDisparcher } from '../Utils/events.js';

const getSelectOptionItemPropValue = (item) => (React__default.isValidElement(item) ? item.props.value : null);
/**
Le select vengono utilizzate quando si ha la necessità di mostrare una serie di contenuti e
permettere all’utente di fare una scelta fra questi.
Le voci del menu possono essere disabilitate se non applicabili ad un certo contesto.
 */
class Select extends React__default.Component {
    constructor(props) {
        super(props);
        this.lastFocus = false;
        this.getTitle = () => {
            const { title, validations } = this.props;
            return getTitle(title, validations);
        };
        this.isValid = () => getValidation(this.valida()).valid;
        this.reset = () => {
            this.setState({
                dirty: false,
            });
        };
        this.clear = () => {
            this.setState({
                selected: null,
            });
        };
        this.close = (e) => {
            if (e.relatedTarget !== e.target && e.relatedTarget != null) {
                setTimeout(() => { this.setState({ visible: false }); }, 100);
            }
        };
        this.closeIfClickOutside = (e) => {
            const { visible } = this.state;
            if (!doesNodeContainClick(this.refNode, e) && visible) {
                this.setState({ visible: false });
            }
        };
        this.valida = () => {
            const { name, value, validations, stato, } = this.props;
            if (!validations)
                return { valid: true };
            let contesto;
            if (stato && name) {
                contesto = stato && name && getProp(name, stato);
            }
            else {
                const { selected } = this.state;
                contesto = value || selected;
            }
            return Validation.validateAll(validations, contesto);
        };
        this.notifica = (evt, value, additionalData, closeSelect) => {
            const { name, onChange, onFormChange, stato, value: valueProp, } = this.props;
            this.setState({
                selected: !name && !valueProp ? value : null,
                visible: !closeSelect,
                dirty: true,
            });
            if (onFormChange && name) {
                const obj = {};
                setProp(name, value, obj, stato);
                onFormChange(obj, name, value);
            }
            if (onChange) {
                onChange(evt, value, additionalData);
            }
        };
        this.changeVisibility = () => {
            const { visible } = this.state;
            if (this.isActive()) {
                if (!visible) {
                    this.lastFocus = true;
                }
                this.setState({ visible: true });
            }
        };
        this.closeIfOpen = () => {
            if (!this.isActive())
                return;
            setTimeout(() => {
                if (this.lastFocus) {
                    this.lastFocus = false;
                }
                else {
                    const { visible } = this.state;
                    if (!visible) {
                        this.setState({ visible: true });
                        return;
                    }
                    this.setState({ visible: false });
                }
            }, 0);
        };
        this.getValue = () => {
            const { name, value, stato } = this.props;
            let contesto;
            if (name) {
                contesto = stato && name && getProp(name, stato);
                if (Array.isArray(contesto)) {
                    contesto = contesto[0]; // eslint-disable-line prefer-destructuring
                }
                if (contesto === '') {
                    contesto = null;
                }
            }
            else {
                const { selected } = this.state;
                contesto = value || selected;
            }
            return contesto;
        };
        this.chiudiTab = (evt) => {
            if (!this.isActive())
                return;
            if (isTabEvent(evt)) {
                this.setState({ visible: false });
            }
        };
        this.seleziona = (evt) => {
            const { children } = this.props;
            if (!this.isActive())
                return;
            const contestoTxt = `${this.getValue()}`;
            let index = -1;
            React__default.Children.map(children, (x, i) => {
                if (`${x.props.value}` === contestoTxt || contestoTxt === '') {
                    index = i;
                }
            });
            if (index === -1)
                return;
            new KeyboardEventDisparcher(evt)
                .onTab(() => {
                if (evt.target !== evt.relatedTarget && evt.relatedTarget != null) {
                    this.setState({ visible: false });
                }
            })
                .onEnter(() => {
                this.setState({ visible: false });
                nodeHelpers.focusNextElement(evt.target);
            })
                .onUp(() => {
                evt.preventDefault();
                index -= 1;
                while (index > -1 && index < React__default.Children.toArray(children).length
                    && getSelectOptionItemPropValue(React__default.Children.toArray(children)[index]) == null) {
                    index -= 1;
                }
            })
                .onDown(() => {
                evt.preventDefault();
                index += 1;
                while (index > -1 && index < React__default.Children.toArray(children).length
                    && getSelectOptionItemPropValue(React__default.Children.toArray(children)[index]) == null) {
                    index += 1;
                }
            });
            if (index > -1 && index < React__default.Children.toArray(children).length) {
                const item = React__default.Children.toArray(children)[index];
                if (React__default.isValidElement(item)) {
                    this.notifica(evt, item.props.value, item.props.additionalData, false);
                }
            }
        };
        this.scrollOptionIntoView = () => {
            if (this.refSelected == null || this.refList == null)
                return;
            const menuDOM = this.refList;
            const menuRect = menuDOM.getBoundingClientRect();
            setTimeout(() => {
                const n = findDOMNode(this.refSelected); // eslint-disable-line react/no-find-dom-node
                if (n) {
                    const selectedRect = n.getBoundingClientRect();
                    if (selectedRect.bottom > (menuRect.bottom - 5) || selectedRect.top < menuRect.top) {
                        menuDOM.scrollTop = (n.offsetTop + n.clientHeight - menuDOM.offsetHeight);
                    }
                }
            });
        };
        this.renderMenu = (children) => {
            const { customList } = this.props;
            if (customList) {
                return customList(children);
            }
            return (jsx("ul", { className: "select__list", ref: (r) => { this.refList = r; }, children: children }));
        };
        this.isActive = () => {
            const { disabled, readOnly } = this.props;
            return !disabled && !readOnly;
        };
        this.uniqueid = getRandomId();
        this.state = {
            dirty: false,
            visible: false,
            selected: null,
        };
    }
    componentDidMount() {
        const { name, addToForm } = this.props;
        document.addEventListener('click', this.closeIfClickOutside);
        if (addToForm && name) {
            addToForm(name, this.valida(), this.reset);
        }
    }
    componentWillUnmount() {
        const { name, removeFromForm } = this.props;
        document.removeEventListener('click', this.closeIfClickOutside);
        if (removeFromForm && name) {
            removeFromForm(name);
        }
    }
    render() {
        const { actions, children, className, isValid, name, right, title, validare, readOnly: readOnlyProp, disabled: disabledProp, ellipsis, placeholder, } = this.props;
        const { dirty, visible } = this.state;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { disabled, readOnly } = useActivation(disabledProp, readOnlyProp); // NOSONAR
        const contesto = this.getValue();
        const contestoTxt = `${contesto}`;
        const validazione = getValidation(this.valida());
        if (isValid != null && name) {
            isValid(name, validazione.valid, validazione.messages || []);
        }
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { hasError, hasWarning } = useValidations(validare, dirty, validazione); // NOSONAR
        const classes = cns('select input', hasError ? 'select--invalid' : 'select--valid', {
            'select--right': right,
            'select--disabled': !this.isActive(),
        }, className);
        const listTitleClasses = cns('select__listTitle', {
            'select__listTitle--disabled': disabled,
            'select__listTitle--default': false,
            'select__listTitle--readOnly': readOnly,
        });
        const inputTitleClass = cns('select__title', { 'select__title--readOnly': readOnly });
        const childrenWithProps = React__default.Children.map(children, (child) => React__default.cloneElement(child, {
            notifica: this.notifica,
            ref: (`${child.props.value}` === contestoTxt || contestoTxt === '') ? (r) => { this.refSelected = r; } : () => { },
            value: child.props.value,
            isSelected: `${child.props.value}` === contestoTxt || contestoTxt === '',
        })) || [];
        const value = childrenWithProps.find((x) => `${x.props.value}` === contestoTxt || contestoTxt === '')
            ? childrenWithProps.find((x) => `${x.props.value}` === contestoTxt || contestoTxt === '').props.children
            : contesto || '';
        const tabIndex = {};
        if (disabled) {
            tabIndex.tabIndex = -1;
        }
        if (visible && childrenWithProps.length > 0 && this.refSelected) {
            this.scrollOptionIntoView();
        }
        const label = name || title;
        return (jsxs("div", { className: classes, ref: (r) => { this.refNode = r; }, children: [jsxs("div", { className: "select__container", children: [jsxs("div", { className: "select__wrapper validationViewer__target", children: [readOnly
                                    ? (jsx("span", { className: listTitleClasses, children: jsx(EllipsisText, Object.assign({}, ellipsis, { children: new Presentation({ readOnly }).format(value) })) })) : (jsx("input", Object.assign({ id: this.uniqueid, autoComplete: `select-${this.uniqueid}`, className: listTitleClasses, "data-origin": name, onClick: this.closeIfOpen, onFocus: this.changeVisibility, onKeyDown: this.chiudiTab, onKeyUp: this.seleziona, disabled: disabled, readOnly: !disabled, value: new Presentation({ readOnly }).format(value), placeholder: placeholder }, tabIndex))), label && jsx("label", { htmlFor: this.uniqueid, className: "input__label", children: label }), title && jsx("span", { className: inputTitleClass, children: this.getTitle() }), !readOnly && jsx("span", { className: !visible ? 'select__listItemArrow' : 'select__listItemArrow close' }), jsx("span", { className: "select__bar" }), visible && this.renderMenu(childrenWithProps)] }), jsx(ValidationViewer, { hasError: hasError, hasWarning: hasWarning, validazione: validazione })] }), !readOnly && actions && jsx("div", { className: "select__actions", children: actions })] }));
    }
}
Select.Option = Option;
Select.Divider = Divider;
Select.defaultProps = {
    className: null,
    name: null,
    onChange: null,
    title: null,
    validations: null,
    value: null,
    disabled: false,
    readOnly: false,
    ellipsis: {
        left: false,
        top: true,
        disabled: false,
    },
    placeholder: undefined,
    children: undefined,
    actions: undefined,
    customList: undefined,
    right: undefined,
};

export { Select as default };
